import { fetchAuthSession } from "aws-amplify/auth";
import axios, { CanceledError } from "axios";
import { useLoadingStore } from "./loading.store";

const api = axios.create({
	baseURL: "", // Use environment variables
	timeout: 30000,
	headers: {
		"Content-Type": "application/json",
		Accept: "application/json",
	},
});

api.interceptors.request.use(
	async (config) => {
		useLoadingStore.getState().startLoading();

		// Skip auth for public endpoints (ENGAGEMENT_API has no Cognito authorizer)
		const engagementApi = process.env.NEXT_PUBLIC_ENGAGEMENT_API;
		const isPublicEndpoint =
			engagementApi && config.url?.startsWith(engagementApi);

		// Skip auth when explicitly flagged (e.g., pre-confirmation registration calls)
		const skipAuth = (config as { skipAuth?: boolean }).skipAuth === true;

		if (!isPublicEndpoint && !skipAuth) {
			try {
				const { tokens } = await fetchAuthSession();
				if (tokens?.idToken) {
					config.headers.Authorization = `Bearer ${tokens.idToken.toString()}`;
				}
			} catch {
				// No active session — proceed without token
			}
		}

		return config;
	},
	(error) => {
		useLoadingStore.getState().stopLoading();
		return Promise.reject(error);
	},
);

api.interceptors.response.use(
	(response) => {
		useLoadingStore.getState().stopLoading();
		return response;
	},
	(error) => {
		useLoadingStore.getState().stopLoading();
		// Handle global errors, e.g., unauthorized or network issues
		return Promise.reject(error);
	},
);

export default api;

export { CanceledError };
